webpackJsonp([1],{

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_index_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__page_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_ranklist_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_ranklist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__page_ranklist_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_activity_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_activity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page_activity_vue__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_2__page_index_vue___default.a
  }, {
    path: '/ranklist',
    name: 'ranklist',
    component: __WEBPACK_IMPORTED_MODULE_3__page_ranklist_vue___default.a
  }, {
    path: '/activity',
    name: 'activity',
    component: __WEBPACK_IMPORTED_MODULE_4__page_activity_vue___default.a
  }]
}));

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(473)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  "data-v-def53c3c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_introduce_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_introduce_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_components_introduce_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_vote_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_vote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__src_components_vote_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_rank_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_rank_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__src_components_rank_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_js_data__ = __webpack_require__(91);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    introduce: __WEBPACK_IMPORTED_MODULE_5__src_components_introduce_vue___default.a,
    vote: __WEBPACK_IMPORTED_MODULE_6__src_components_vote_vue___default.a,
    rank: __WEBPACK_IMPORTED_MODULE_7__src_components_rank_vue___default.a
  },
  data: function data() {
    return {
      username: "",
      bannerData: {},
      typeData: {},
      defaultDate: [],
      examDate: {},
      baseUrl: '',

      currentComp: 'vote',

      isActive: '2',
      menuData: __WEBPACK_IMPORTED_MODULE_8__common_js_data__["a" /* menu */]
    };
  },

  computed: {},
  mounted: function mounted() {
    if (false) {
      this.baseUrl = 'http://www.yooc.test';
      this.$cookies.set('sessionid', '4b27961d53ee3d34828ecec181fa99e4');
    } else {
      if (undefined === 'test') {
        this.baseUrl = 'http://www.yooc.test';
      } else {
        this.baseUrl = 'https://www.yooc.me';
      }
    };
  },


  methods: {
    linkto: function linkto() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var URL;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                URL = _this.Host + '/upload/check';
                _context.next = 3;
                return _this.$axios.get(URL).then(function (res) {
                  var code = res.data.code;
                  if (code == 404) {
                    window.location.href = "/login";
                  } else if (code == 403) {
                    _this.$message.error(res.data.message);
                  } else {
                    window.open("/dashboard/course/edit?origin=youke2024");
                  }

                  console.log(res.result);
                }).catch(function (error) {
                  console.error(error);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    linkto100: function linkto100() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                window.open("https://www.yooc.me/youke2024/result100");

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {},


  methods: {}
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_js_data__ = __webpack_require__(91);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  components: {},
  data: function data() {
    return {
      username: "",
      category: 1,
      rankdata: {},
      baseUrl: '',
      isActive: 1,
      categoryData: __WEBPACK_IMPORTED_MODULE_5__common_js_data__["b" /* categoryData */],
      videoPop: false,
      videoUrl: ''

    };
  },

  computed: {},
  mounted: function mounted() {
    if (false) {
      this.baseUrl = 'http://www.yooc.test';
    } else {
      if (undefined === 'test') {
        this.baseUrl = 'http://www.yooc.test';
      } else {
        this.baseUrl = 'https://www.yooc.me';
      }
    };
    this.getRankList(this.category);
  },
  craeted: function craeted() {},

  methods: {
    getRankList: function getRankList(category) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var URL;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                URL = _this.Host + '/rank';
                _context.next = 3;
                return _this.$axios.get(URL, { params: { category: category } }).then(function (res) {
                  var result = res.data.result;
                  if (!result) {
                    return;
                  }
                  _this.rankdata = res.data.data.courses;
                }).catch(function (error) {
                  console.error(error);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    videoDetail: function videoDetail(url) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.videoUrl = url;
                _this2.videoPop = true;

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeVideoPop: function closeVideoPop() {
      var video = document.getElementById("video");
      video.pause();
      this.videoUrl = '';
    },
    getrank_top: function getrank_top(index) {
      return 'rank_top_' + index;
    },
    gettop: function gettop(index) {
      return 'rank_top_icon_' + index;
    }
  }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js_data__ = __webpack_require__(91);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      username: "",
      stuNum: {},
      voteNum: {},
      schoolNum: 0,
      coursesNum: 0,
      coursesData: {},
      length: 0,
      category: 1,
      statistics: {},
      baseUrl: '',
      isActive: 1,
      categoryData: __WEBPACK_IMPORTED_MODULE_6__common_js_data__["b" /* categoryData */],
      videoPop: false,
      videoUrl: '',
      keyword: '',
      page: 1,
      courses: {}
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "videoPop", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "videoUrl", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "nums", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "categoryid", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "coursesid", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "votePop", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "a_score_val", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "b_score_val", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "c_score_val", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "vote_state", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "isEnd", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "isVote", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "vote_msg", true), _ref;
  },

  computed: {},
  mounted: function mounted() {
    if (false) {
      this.baseUrl = 'http://www.yooc.test';
      this.$cookies.set('sessionid', '56da471ab99e2c19b8933d587adde65f');
    } else {
      if (undefined === 'test') {
        this.baseUrl = 'http://www.yooc.test';
      } else {
        this.baseUrl = 'https://www.yooc.me';
      }
    };
    this.getStatistics();
    this.getCourses(this.category, this.keyword, this.page);
  },


  methods: {
    getStatistics: function getStatistics() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var URL;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                URL = _this.Host + '/statistics';
                _context.next = 3;
                return _this.$axios.get(URL).then(function (res) {
                  var result = res.data.result;
                  if (!result) {
                    console.error(res.data.message);
                    return;
                  }
                  _this.statistics = res.data.data;
                  _this.stuNum = _this.numberFormat(_this.statistics.total_student);
                  _this.voteNum = _this.numberFormat(_this.statistics.total_vote);
                }).catch(function (error) {
                  console.error(error);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCourses: function getCourses(category, keyword, page) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var URL;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                URL = _this2.Host + '/courses';
                _context2.next = 3;
                return _this2.$axios.get(URL, { params: { category: category, q: keyword, page: page } }).then(function (res) {
                  var result = res.data.result;
                  if (!result) {
                    console.error(res.data.message);
                    return;
                  }
                  _this2.schoolNum = res.data.total_org;
                  _this2.coursesNum = res.data.total;
                  _this2.coursesData = res.data;
                  _this2.length = _this2.coursesData.courses.length;
                  _this2.nums = res.data.nums;
                  _this2.categoryid = res.data.category;
                  if (_this2.coursesData.end != 0) {
                    _this2.isEnd = false;
                  }
                }).catch(function (error) {
                  console.error(error);
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    tabchange: function tabchange(val) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.category = val;

                _this3.page = 1;
                _this3.keyword = '';
                _this3.getCourses(_this3.category, _this3.keyword, _this3.page);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    search: function search() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.getCourses(_this4.category, _this4.keyword, _this4.page);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(currentPage) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.page = currentPage;
                _this5.getCourses(_this5.category, _this5.keyword, _this5.page);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    videoDetail: function videoDetail(url) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.videoUrl = url;
                _this6.videoPop = true;

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    closeVideoPop: function closeVideoPop() {
      var video = document.getElementById("video");
      video.pause();
      this.videoUrl = '';
    },
    voteDetail: function voteDetail(categoryid, courseId, videourl) {
      var _this7 = this;

      this.videoUrl = videourl;
      this.categoryid = parseInt(categoryid);
      this.coursesid = courseId;

      var URL = this.Host + '/user_vote';
      this.$axios.get(URL, { params: { category: categoryid, courseId: courseId } }).then(function (res) {
        var result = res.data.result;

        var error = res.data.error;
        if (error == 403) {
          window.location.href = "/login";
        }
        _this7.vote_state = res.data.data.voted;
        _this7.isVote = res.data.data.voted;

        if (_this7.vote_stat != 0) {
          _this7.a_score_val = res.data.data.a_score;
          _this7.b_score_val = res.data.data.b_score;
          _this7.c_score_val = res.data.data.c_score;
        } else {
          _this7.a_score_val = 0;
          _this7.b_score_val = 0;
          _this7.c_score_val = 0;
        }
        _this7.votePop = true;
      }).catch(function (error) {
        console.error(error);
      });
    },
    tips: function tips() {
      alert('投票评分已结束');
    },
    changeAscore: function changeAscore(val) {},
    changeBscore: function changeBscore(val) {},
    changeCscore: function changeCscore(val) {},
    closeVotePop: function closeVotePop() {
      var video = document.getElementById("vote_video");
      video.pause();
      this.videoUrl = '';
      this.a_score_val = 0;
      this.b_score_val = 0;
      this.c_score_val = 0;
      this.votePop = false;
    },
    useVote: function useVote(a, b, c) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var URL;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                URL = _this8.Host + '/vote';
                _context7.next = 3;
                return _this8.$axios.post(URL, { category: _this8.categoryid,
                  courseId: _this8.coursesid,
                  a_score: a,
                  b_score: b,
                  c_score: c }).then(function (res) {
                  var error = res.data.error;
                  if (error == 403) {
                    window.location.href = "/login";
                  }
                  _this8.videoUrl = '';
                  _this8.a_score_val = 0;
                  _this8.b_score_val = 0;
                  _this8.c_score_val = 0;
                  _this8.votePop = false;
                }).catch(function (error) {
                  console.error(error);
                });

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    numberFormat: function numberFormat(value) {
      var param = {};
      var k = 10000;
      var sizes = ['', '万', '亿', '万亿'];
      var i = void 0;
      if (value < k) {
        param.value = value;
        param.unit = '';
      } else {
        i = Math.floor(Math.log(value) / Math.log(k));
        param.value = (value / Math.pow(k, i)).toFixed(2);
        param.unit = sizes[i];
      }
      return param;
    }
  }
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  components: {},
  data: function data() {
    return {
      username: ""
    };
  },

  computed: {},
  mounted: function mounted() {
    this.getBanner();
  },


  methods: {
    getBanner: function getBanner() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getBannerList();

              case 2:
                res = _context.sent;

                console.log(res);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  components: {},
  data: function data() {
    return {
      username: "",
      bannerData: {},
      typeData: {},
      defaultDate: [],
      examDate: {}
    };
  },

  computed: {},
  mounted: function mounted() {
    this.getBanner();
  },


  methods: {
    monthChanged: function monthChanged() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    selectDay: function selectDay(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var selectdata;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selectdata = data[0].toString() + '-' + data[1] + '-' + data[2];

                if (_this2.defaultDate.indexOf(selectdata) < 0) {
                  Toast("您选的日期内没有关注的考试哦！");
                } else {
                  _this2.$router.push({ name: 'calendarday', params: { day: selectdata } });
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getMyCalendar: function getMyCalendar() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getMyCalendar();

              case 2:
                res = _context3.sent;

                if (res.data.code === 444) {
                  window.location.href = res.data.data;
                } else if (res.data.code === 200) {
                  _this3.defaultDate = res.data.data;
                } else {
                  Toast(res.data.message);
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getBanner: function getBanner() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getRankList();

              case 2:
                res = _context4.sent;

                console.log(res);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getType: function getType() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getIndexType();

              case 2:
                res = _context5.sent;

                if (res.data.code === 444) {
                  window.location.href = res.data.data;
                } else if (res.data.code === 200) {
                  _this5.typeData = res.data.data;
                } else {
                  Toast(res.data.message);
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    getTopCalendar: function getTopCalendar() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getTopCalendar();

              case 2:
                res = _context6.sent;

                if (res.data.code === 444) {
                  window.location.href = res.data.data;
                } else if (res.data.code === 200) {
                  _this6.examDate = res.data.data;
                } else {
                  Toast(res.data.message);
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    gotolink: function gotolink(id) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.$router.push({ name: 'typelist', params: { fid: id } });

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    gotoexamlink: function gotoexamlink(id) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.$router.push({ name: 'examdetail', params: { id: id } });

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    }
  }
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  components: {},
  data: function data() {
    return {
      username: ""
    };
  },

  computed: {},
  mounted: function mounted() {
    this.getBanner();
  },


  methods: {
    getBanner: function getBanner() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getBannerList();

              case 2:
                res = _context.sent;

                console.log(res);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bus__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookies__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_polyfill__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_iconfont_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_css_main_scss__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_css_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_css_main_scss__);














__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.Host = '/youke2024/api';
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_bus__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default.a, {
  size: 'medium'
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);



var baseURL = void 0;

if (false) {
  baseURL = '';
} else {
  if (undefined === 'test') {
    baseURL = '';
  } else if (undefined === 'pre') {
    baseURL = '';
  } else {
    baseURL = '';
  }
}
var request = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: baseURL,
  withCredentials: true,
  timeout: 10000
});

/* harmony default export */ __webpack_exports__["a"] = ({
  baseURL: baseURL,

  getCoursesList: function getCoursesList(params) {
    return request.get('/youke2024/api/courses', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params));
  },

  getRankList: function getRankList(params) {
    return request.get('/youke2024/api/rank', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params));
  },

  getStatistics: function getStatistics(params) {
    return request.get('/youke2024/api/statistics', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params));
  },

  getUser_vote: function getUser_vote(params) {
    return request.get('/youke2024/api/user_vote', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params));
  },

  getVote: function getVote(params) {
    return request.post('/youke2024/api/vote', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params));
  }
});

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_1.43f0846.png";

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(471)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  "data-v-6e959255",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(470)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(499),
  /* scopeId */
  "data-v-107a2fe6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(472)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(501),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(500),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 499:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "rank_index",
    staticClass: "rank_index"
  }, [_c('div', {
    staticClass: "rank_index_top"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "tab_box"
  }, _vm._l((this.categoryData), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        act: (_vm.isActive == item.category ? true : false)
      },
      on: {
        "click": function($event) {
          _vm.getRankList(item.category);
          _vm.isActive = item.category;
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.value) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rank_index_icon left_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "rank_index_icon right_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "rank_index_fg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "rank_center_box"
  }, [(this.rankdata.length > 0) ? _c('div', {
    staticClass: "rank_list_box"
  }, _vm._l((this.rankdata), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "rank_list",
      class: _vm.getrank_top(index + 1)
    }, [_c('div', {
      staticClass: "rank_list_t"
    }, [_c('span', {
      staticClass: "rank_name",
      on: {
        "click": function($event) {
          return _vm.videoDetail(item.video_url)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "rank_num"
    }, [_vm._v("\n            总得分数："), _c('span', [_vm._v(_vm._s(item.total_score))]), _vm._v("分\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "rank_list_b"
    }, [_c('span', {
      staticClass: "rank_org"
    }, [_vm._v(_vm._s(item.org))]), _vm._v(" "), _c('span', {
      staticClass: "rank_vote"
    }, [_vm._v("投票数：" + _vm._s(item.total_vote) + "人")]), _vm._v(" "), _c('span', {
      staticClass: "rank_id"
    }, [_vm._v("视频ID：" + _vm._s(item.id))])]), _vm._v(" "), (index == 0) ? _c('div', {
      staticClass: "top_icon top_1"
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('div', {
      staticClass: "top_icon top_2"
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('div', {
      staticClass: "top_icon top_3"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rank_top_icon",
      class: _vm.gettop(index + 1)
    })])
  }), 0) : _c('div', {
    staticClass: "list_null"
  }, [_vm._v("暂无数据！！！")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频预览",
      "visible": _vm.videoPop,
      "width": "550px",
      "top": "200px",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoPop = $event
      },
      "close": _vm.closeVideoPop
    }
  }, [(_vm.videoUrl) ? _c('div', {
    staticClass: "video_box"
  }, [_c('video', {
    ref: "video",
    attrs: {
      "id": "video",
      "width": "500",
      "height": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": this.videoUrl,
      "type": "video/mp4"
    }
  }), _vm._v("\n        您的浏览器不支持 video 标签。\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rank_top"
  }, [_vm._v("投票活动截止到"), _c('span', [_vm._v("2024年8月31日")]), _vm._v("，最终获奖名单将于"), _c('span', [_vm._v("10月")]), _vm._v("公布，榜单每日更新一次。")])
}]}

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home_index",
    staticClass: "home_index"
  }, [_vm._v("\n  公告列表\n")])
},staticRenderFns: []}

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "index_box",
    staticClass: "index_box"
  }, [_vm._v("\n 1\n  ")])
},staticRenderFns: []}

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "introduce_box",
    staticClass: "introduce_box"
  }, [_c('div', {
    staticClass: "tit_bg"
  }, [_vm._v("2024年度易班优质公开课征集评选活动方案")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "msg_tit tit_1"
  }, [_vm._v("参与对象")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "msg_tit tit_2"
  }, [_vm._v("活动时间")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "msg_tit tit_3"
  }, [_vm._v("课程类型")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "msg_tit tit_4"
  }, [_vm._v("参赛方式及要求")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "msg_tit tit_5"
  }, [_vm._v("投票及评审规则")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_box"
  }, [_c('p', [_vm._v("为进一步推动全国高校思想政治工作会议精神落地生根，深入贯彻落实上海高校思想政治工作会议的决策部署，抓好课堂育人、实践育人、网络育人的改革创新，增强互联网意识，易班网打造了“互联网+思政教育”一体化解决方案“易班优课”在线教学平台，整合易班共建高校优质教学资源，形成网上网下教育合力。")]), _vm._v(" "), _c('p', [_vm._v("今年易班优课平台为服务师生各项教学使用需求，将面向全国征集以高校新生入学教育、高校日常思政教育、大学生职业素养教育、大学生心理健康教育、大学生安全教育等5项专题内容为主的视频课程，每个分类评选出10部精品课程，总计50部，向全国高校进行专题推广宣传。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_box"
  }, [_vm._v("\n    全国易班共建高校"), _c('br'), _vm._v("\n    活动页网址："), _c('a', {
    attrs: {
      "href": "https://www.yooc.me/youke2024"
    }
  }, [_vm._v("https://www.yooc.me/youke2024")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_box"
  }, [_vm._v("\n    活动时间：6月1日-9月30日"), _c('br'), _vm._v("\n    课程征集时间：2024年1月1日-2024年8月31日"), _c('br'), _vm._v("\n    投票评分时间：2024年6月1日-2024年8月31日"), _c('br'), _vm._v("\n    专家评审时间：2024年9月"), _c('br'), _vm._v("\n    获奖公示时间：2024年10月"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_box"
  }, [_c('b', [_vm._v("课程类型一：高校新生入学教育")]), _c('br'), _vm._v("\n    围绕“高校新生入学教育”的主题上传相关公开视频课程，帮助新生坚定理想信念，养成良好学风，勇于拼搏奋斗，提升素质能力。"), _c('br'), _vm._v(" "), _c('b', [_vm._v("课程类型二：高校日常思政教育")]), _c('br'), _vm._v("\n    围绕“高校日常思政教育”（包括：“四史”学习、学习二十大、高校思政教育、形势与政策、思政理论课、思政易家、课程思政）的主题上传相关公开视频课程，引领学生树立共产主义远大理想和中国特色社会主义共同理想。"), _c('br'), _vm._v(" "), _c('b', [_vm._v("课程类型三 ：大学生职业素养教育")]), _c('br'), _vm._v("\n    围绕“大学生职业素养教育”的主题上传相关公开视频课程，构建完善的大学生职业素养教育体系,引导大学生自我提高职业素养,为社会培养更多有用人。"), _c('br'), _vm._v(" "), _c('b', [_vm._v("课程类型四 ：大学生心理健康教育")]), _c('br'), _vm._v("\n    围绕“大学生心理健康教育”的主题上传相关公开视频课程，引导学生正确认识义和利、群和己、成和败、得和失，培育学生自尊自信、理性平和、积极向上的健康心态，促进学生心理健康素质与思想道德素质、科学文化素质协调发展。"), _c('br'), _vm._v(" "), _c('b', [_vm._v("课程类型五：大学生安全教育")]), _c('br'), _vm._v("\n    围绕“大学生安全教育”的主题上传相关公开视频课程，课程内容可包括但不限于：意识形态安全、国家安全、人身安全、消防安全、交通安全、财产安全、网络信息安全和防灾减灾救灾等方面的教育培训。"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_box"
  }, [_c('b', [_vm._v("参赛方式：")]), _c('br'), _vm._v("\n    方式一：课程征集截止前，在活动专题页点击“上传参赛课程”按钮，提交参赛视频课程，通过易班工作人员初审后，成功显示在专题活动页上的课程，表示为申报成功。"), _c('br'), _vm._v("\n    方式二：2024年1月1日-课程征集截止日，成功在易班优课“共享课程”频道上线的公开课视频，对应相关的课程分类主题，时长在5分钟以上的课程会自动进入易班工作人员初审平台，审核通过成功显示在专题活动页上的课程，表示为申报成功。\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_box"
  }, [_c('b', [_vm._v("上传分类选择规则")]), _c('br'), _vm._v(" "), _c('var'), _vm._v("“高校新生入学教育”请选择“易班学院-新生教育课”；"), _c('br'), _vm._v(" "), _c('var'), _vm._v("“高校日常思政教育”请选择“易班学院-‘四史’学习、学习二十大、高校思政教育、形势与政策、思政理论课、思政易家、课程思政”；"), _c('br'), _vm._v(" "), _c('var'), _vm._v("“大学生职业素养教育”请选择“易班大学-职业素养”；"), _c('br'), _vm._v(" "), _c('var'), _vm._v("“大学生心理健康教育”请选择“易班学院-心理健康教育”；"), _c('br'), _vm._v(" "), _c('var'), _vm._v("“大学生安全教育”请选择“易班学院-安全教育”。"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_box"
  }, [_c('b', [_vm._v("视频课程格式要求")]), _c('br'), _vm._v(" "), _c('var'), _vm._v("1个课程对应1个视频；"), _c('br'), _vm._v(" "), _c('var'), _vm._v("单个视频时长必须超过5分钟；"), _c('br'), _vm._v(" "), _c('var'), _vm._v("视频文件类型为MP4；单个上传文件大小不能超过500M；"), _c('br'), _vm._v(" "), _c('var'), _vm._v("课程封面必须设计精美，格式:jpg/png ；尺寸:500*375 ；文件大小<500k；课程封面上需要有“课程名称+高校名称”；"), _c('br'), _vm._v(" "), _c('var'), _vm._v("视频流：视频编码H.264；比特率建议384;"), _c('br'), _vm._v(" "), _c('var'), _vm._v("音频流：音视频编码AAC；比特率建议96；"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_box"
  }, [_c('b', [_vm._v("已上线课程修改方式")]), _c('br'), _vm._v("\n    老师对已经通过易班初审上线的课程需要进行修改，包括文字修改和视频修改，请联系易班优课运营老师，提交修改内容后，由易班优课运营老师人工修改。"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg_box"
  }, [_c('var'), _vm._v("所有参赛课程，视频时长超过5分钟的才能进入易班初审流程。"), _c('br'), _vm._v(" "), _c('var'), _vm._v("所有进入初审流程的课程，必须通过易班工作人员的人工初审，审核通过才进入专题展示页，进行公示投票评分。"), _c('br'), _vm._v(" "), _c('var'), _vm._v("本次活动首先进行全国师生的投票评分，在投票截止日之后，每个分类选总评分最高的10部课程，总计50部课程进入决赛。相关投票评分规则如下："), _c('br'), _vm._v("\n    （1）活动期间，每人只能为每部课程投票及评分一次，8月31日停止投票和评分。"), _c('br'), _vm._v("\n    （2）评分将以：课程内容、讲师表现、拍摄质量三个维度作为评判标准，每个维度最多评3分，基础投票得1分，总计10分。"), _c('br'), _vm._v("\n    （3）课程排行榜每天公示昨天五个分类总分最高的50部课程，8月31日之后停止投票、评分和排行榜更新。"), _c('br'), _vm._v(" "), _c('var'), _vm._v("8月31日之后，易班工作人员在每个课程分类未进入前十名的课程里挑选推荐10部课程并撰写推荐理由，总计50部课程进入决赛。挑选原则以视频内容和拍摄质量为主要评判依据。"), _c('br'), _vm._v(" "), _c('var'), _vm._v("9月份，公示进入决赛的100部课程名单。"), _c('br'), _vm._v("\n    公示网址："), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("https://www.yooc.me/youke2024/result100")]), _c('br'), _vm._v(" "), _c('var'), _vm._v("9月份，易班组织专家组对100部进入决赛的课程进行评分，以专家组最终的评分和意见作为最终评选依据，每个分类评选出10部精品课程，分为一、二、三等奖和7个优秀奖，总计50部精品课程。专家评分相同的时候，以课程获得的投票总评分排序。"), _c('br'), _vm._v(" "), _c('var'), _vm._v("10月份，在专家评审结束后，易班总部会对50部获奖课程进行风格统一的包装制作，颁发相应的易班电子证书，并制作专题展示页进行相关的公示、宣传。"), _c('br'), _vm._v("\n    公示网址："), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("https://www.yooc.me/youke2024/result50")]), _c('br'), _vm._v(" "), _c('var'), _vm._v("活动结束后，每部获奖课程会颁发一份易班电子证书，5个分类总计50份，电子证书可以在“易班电子证书查询系统”中查询，证书上包括：课程名称、学校名称等信息。"), _c('br'), _vm._v("\n    易班电子证书查询系统网址："), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.yiban.cn/Renzheng/showJzList#/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.yiban.cn/Renzheng/showJzList#/")]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zs_box"
  }, [_c('p', [_vm._v("证书样式")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(492)
    }
  }), _vm._v(" "), _c('em', [_vm._v("易班在法律允许范围内对本活动保留最终解释权。")])])
}]}

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home_index",
    staticClass: "home_index"
  }, [_vm._v("\n  作品列表\n")])
},staticRenderFns: []}

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "vote_index",
    staticClass: "vote_index"
  }, [_c('div', {
    staticClass: "vote_index_top"
  }, [_c('div', {
    staticClass: "vote_top"
  }, [_vm._v("已有"), _c('span', [_vm._v(_vm._s(this.schoolNum))]), _vm._v("所高校"), _c('span', [_vm._v(_vm._s(this.coursesNum))]), _vm._v("部课程参赛评选，"), _c('span', [_vm._v(_vm._s(_vm.stuNum.value) + _vm._s(_vm.stuNum.unit))]), _vm._v("名学生总计投票"), _c('span', [_vm._v(_vm._s(_vm.voteNum.value) + _vm._s(_vm.voteNum.unit))]), _vm._v("次")]), _vm._v(" "), _c('ul', {
    staticClass: "tab_box"
  }, _vm._l((this.categoryData), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        act: (_vm.isActive == item.category ? true : false)
      },
      on: {
        "click": function($event) {
          _vm.tabchange(item.category);
          _vm.isActive = item.category;
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.value) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "vote_index_icon left_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "vote_index_icon right_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "vote_index_fg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "vote_center"
  }, [_c('div', {
    staticClass: "vote_search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "maxlength": "50",
      "placeholder": "按高校名称进行搜索"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), (this.length > 0) ? _c('div', {
    staticClass: "vote_list_box"
  }, _vm._l((this.coursesData.courses), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "vote_list"
    }, [_c('img', {
      staticClass: "vote_img",
      attrs: {
        "src": item.img
      },
      on: {
        "click": function($event) {
          return _vm.videoDetail(item.video_url)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "vote_name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "vote_id"
    }, [_vm._v("视频ID："), _c('label', [_vm._v(_vm._s(item.id))])]), _vm._v(" "), _c('p', {
      staticClass: "vote_org"
    }, [_vm._v(_vm._s(item.org))]), _vm._v(" "), _c('p', {
      staticClass: "vote_msg"
    }, [_c('span', {
      staticClass: "vote_msg_l"
    }, [_vm._v("总评分："), _c('label', [_vm._v(_vm._s(item.score))]), _vm._v("分")]), _c('span', {
      staticClass: "vote_msg_r"
    }, [_vm._v("总投票："), _c('label', [_vm._v(_vm._s(item.vote))]), _vm._v("人")])]), _vm._v(" "), _c('div', {
      staticClass: "vote_btn vote_over_btn"
    }, [_vm._v("投票已结束")])])
  }), 0) : _c('div', {
    staticClass: "list_null"
  }, [_vm._v("暂无数据！！！")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.length > 0),
      expression: "this.length>0"
    }],
    staticClass: "page_box"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "pager",
      "page-size": 12,
      "total": this.nums
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频预览",
      "visible": _vm.videoPop,
      "width": "550px",
      "top": "200px",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoPop = $event
      },
      "close": _vm.closeVideoPop
    }
  }, [(_vm.videoUrl) ? _c('div', {
    staticClass: "video_box"
  }, [_c('video', {
    attrs: {
      "id": "video",
      "width": "500",
      "height": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": this.videoUrl,
      "type": "video/mp4"
    }
  }), _vm._v("\n        您的浏览器不支持 video 标签。\n      ")])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "课程投票",
      "visible": _vm.votePop,
      "width": "550px",
      "top": "200px",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.votePop = $event
      },
      "close": _vm.closeVotePop
    }
  }, [(_vm.videoUrl) ? _c('div', {
    staticClass: "video_box"
  }, [_c('video', {
    attrs: {
      "id": "vote_video",
      "width": "500",
      "height": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": this.videoUrl,
      "type": "video/mp4"
    }
  }), _vm._v("\n        您的浏览器不支持 video 标签。\n      ")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "vote_list"
  }, [_c('li', [_c('span', [_vm._v("课程内容")]), _vm._v(" "), _c('div', {
    staticClass: "star_box"
  }, [_c('el-rate', {
    attrs: {
      "max": 3,
      "disabled": _vm.isVote != 0
    },
    on: {
      "change": _vm.changeAscore
    },
    model: {
      value: (_vm.a_score_val),
      callback: function($$v) {
        _vm.a_score_val = $$v
      },
      expression: "a_score_val"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', [_vm._v("讲师表现")]), _vm._v(" "), _c('div', {
    staticClass: "star_box"
  }, [_c('el-rate', {
    attrs: {
      "max": 3,
      "disabled": _vm.isVote != 0
    },
    on: {
      "change": _vm.changeBscore
    },
    model: {
      value: (_vm.b_score_val),
      callback: function($$v) {
        _vm.b_score_val = $$v
      },
      expression: "b_score_val"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', [_vm._v("拍摄质量")]), _vm._v(" "), _c('div', {
    staticClass: "star_box"
  }, [_c('el-rate', {
    attrs: {
      "max": 3,
      "disabled": _vm.isVote != 0
    },
    on: {
      "change": _vm.changeCscore
    },
    model: {
      value: (_vm.c_score_val),
      callback: function($$v) {
        _vm.c_score_val = $$v
      },
      expression: "c_score_val"
    }
  })], 1)])]), _vm._v(" "), (_vm.vote_state == 0) ? _c('div', {
    staticClass: "pop_vote_btn",
    on: {
      "click": function($event) {
        return _vm.useVote(_vm.a_score_val, _vm.b_score_val, _vm.c_score_val)
      }
    }
  }, [_vm._v("投票")]) : (_vm.vote_state == 1) ? _c('div', {
    staticClass: "pop_vote_btn_over"
  }, [_vm._v("已投票")]) : (_vm.vote_state == 2) ? _c('div', {
    staticClass: "pop_vote_btn_over"
  }, [_vm._v("投票已达3000人上限")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "top_box"
  }, [_c('div', {
    staticClass: "apply_btn",
    on: {
      "click": function($event) {
        return _vm.linkto100()
      }
    }
  }, [_vm._v("查看100部入围决赛的课程")])]), _vm._v(" "), _c('div', {
    staticClass: "center_box"
  }, [_c('div', {
    staticClass: "nav_box"
  }, _vm._l((this.menuData), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        act: (_vm.isActive == item.value ? true : false)
      },
      on: {
        "click": function($event) {
          _vm.isActive = item.value;
          _vm.currentComp = item.comp
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "center_nr_box"
  }, [_c(_vm.currentComp, {
    tag: "introduce"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return categoryData; });
var menu = [{
  name: '活动介绍',

  value: '1',

  comp: 'introduce'
}, {
  name: '投票区',
  value: '2',
  comp: 'vote'
}, {
  name: '排行榜',
  value: '3',
  comp: 'rank'
}];
var categoryData = [{
  category: '1',
  value: '高校新生入学教育'
}, {
  category: '2',
  value: '高校日常思政教育'
}, {
  category: '3',
  value: '大学生职业素养教育'
}, {
  category: '4',
  value: '大学生心理健康教育'
}, {
  category: '5',
  value: '大学生安全教育'
}];

/***/ })

},[221]);


// WEBPACK FOOTER //
// static/js/app.378fccc25ed4e290ea0b.js